import addVendorScript from '@/shared/util/addVendorScript';

const apiKey = CONFIG.GOOGLE_MAPS_TOKEN;
addVendorScript(`https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`);
